
import { defineComponent, PropType, ref } from 'vue'
import { HierarchyAssignment, MemberProfile } from '@/modules/members'
import MembersEditMemberHierarchyAssignmentDialog
    from '@/components/members/dialogs/edit-member-hierarchy-assignment.vue'
import useQuasar from 'quasar/src/composables/use-quasar.js';

export default defineComponent({
    name: 'members-update-hierarchy-assignment',
    props: {
        member: {
            type: Object as PropType<MemberProfile>,
            required: true
        }
    },
    setup (props) {
        const $q = useQuasar()
        const localModel = ref(props.member.hierarchyAssignment)

        const onValueUpdated = (newValue: HierarchyAssignment) => {
            localModel.value = newValue
        }

        function onChangeHierarchyAssignment () {
            $q.dialog({
                component: MembersEditMemberHierarchyAssignmentDialog,
                componentProps: {
                    organizationId: props.member.organizationId,
                    memberId: props.member.memberId,
                    hierarchyAssignment: { ...localModel.value },
                    updateCallback: onValueUpdated
                }
            })
        }

        return {
            localModel,
            onChangeHierarchyAssignment
        }
    }
})
